import type { SVGProps } from 'react';
export const Home = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      d="M10 4.42 4.84 9.35v6.3h2.9V12.4q0-.48.34-.86.35-.36.86-.37h2.12q.51.01.86.37.34.38.34.86v3.24h2.9v-6.3zm-.82-1.09a1.2 1.2 0 0 1 1.64 0l5.3 5.08a1.3 1.3 0 0 1 .38.89v6.46q0 .5-.34.87-.35.36-.86.37h-3.18q-.51-.01-.86-.37a1.3 1.3 0 0 1-.34-.87v-3.23H9.08v3.23q0 .5-.34.87-.35.36-.86.37H4.7q-.51-.01-.86-.37a1.3 1.3 0 0 1-.34-.87V9.3a1.3 1.3 0 0 1 .37-.88l.01-.01z"
      clipRule="evenodd"
    />
  </svg>
);
